import React from "react";
import "./InteriorHolding.css"; // Import the CSS file
import image from "../assets/StudioAeksentMarloes.jpg"; // Update with the correct path
import instagramLogo from "../assets/instagram-logo.svg"; // Import the Instagram logo

const InteriorHolding = () => {
  return (
    <div className="holding-container">
      {/* Left Section with Image */}
      <div className="image-section">
        <img src={image} alt="Marloes Hilbers" className="holding-image" />
      </div>

      {/* Right Section with Text */}
      <div className="text-section">
        <h2 className="studio-title">
          <span className="seasons-font studio-text">studio</span>
          <span className="montserrat-font aeksent-text non-bold">Aeksent</span>
        </h2>
        <p className="subtitle">Interiors by Marloes Hilbers</p>
        <p className="coming-soon">Great things are coming..</p>
        
        <p className="instagram-text">
          Visit Instagram to enter my world |{" "}
          <a
            href="https://www.instagram.com/studio_aeksent_interiors"
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-link"
          >
            <img src={instagramLogo} alt="Instagram" className="instagram-icon" />
            studio_aeksent_interiors
          </a>
        </p>
        
        <p className="contact-text">
          T: <a href="tel:+31610822279" className="contact-link">+31 6 108 222 79</a>
        </p>
        <p className="contact-text">
          E: <a href="mailto:marloes@studioaeksent.nl" className="contact-link">marloes@studioaeksent.nl</a>
        </p>
      </div>
    </div>
  );
};

export default InteriorHolding;
